import { render } from "./PhotosHome.vue?vue&type=template&id=4ee4d4ac&ts=true"
import script from "./PhotosHome.vue?vue&type=script&lang=ts"
export * from "./PhotosHome.vue?vue&type=script&lang=ts"

import "./PhotosHome.vue?vue&type=style&index=0&id=4ee4d4ac&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__